import React from 'react'
import MessageSubmissions from '../notifications/MessageSubmissions'



const SMS = () => {

  const maincardtitle= (<div className='text-center mt-2'>Uprocessed Messages</div>);

  return (
    <>
      <MessageSubmissions
        maincardtitlex={maincardtitle }
      />
    </>
  )
}

export default SMS